// DOM visibility helpers for the dynamic component renderer's placeholder
// (skeleton) and fallback (legacy content). Kept separate from index.tsx so
// they're unit-testable without the SES/Babel render machinery.

export function hide(selector?: string): void {
  if (!selector) return;
  const el = document.querySelector(selector);
  if (el instanceof HTMLElement) el.style.display = 'none';
}

export function reveal(selector?: string): void {
  if (!selector) return;
  const el = document.querySelector(selector);
  if (el instanceof HTMLElement) el.style.display = '';
}
